import React from 'react'
import { useLocation } from 'react-router-dom'

export const ScrollTop = () => {
  const location = useLocation()

  React.useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [location.pathname])

  return null
}
